"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
exports.__esModule = true;
exports.asyncQueue = exports.endpointByCurrencyId = exports.drainSeqAsyncGen = exports.assertUnreachable = void 0;
var web3_js_1 = require("@solana/web3.js");
var env_1 = require("../../env");
var assertUnreachable = function (_) {
    throw new Error("unreachable assertion failed");
};
exports.assertUnreachable = assertUnreachable;
function drainSeqAsyncGen() {
    var e_1, _a;
    var asyncGens = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncGens[_i] = arguments[_i];
    }
    return __awaiter(this, void 0, void 0, function () {
        var items, asyncGens_1, asyncGens_1_1, gen, gen_1, gen_1_1, item, e_1_1, e_2_1;
        var e_2, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    items = [];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 16, 17, 18]);
                    asyncGens_1 = __values(asyncGens), asyncGens_1_1 = asyncGens_1.next();
                    _c.label = 2;
                case 2:
                    if (!!asyncGens_1_1.done) return [3 /*break*/, 15];
                    gen = asyncGens_1_1.value;
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 8, 9, 14]);
                    gen_1 = (e_1 = void 0, __asyncValues(gen));
                    _c.label = 4;
                case 4: return [4 /*yield*/, gen_1.next()];
                case 5:
                    if (!(gen_1_1 = _c.sent(), !gen_1_1.done)) return [3 /*break*/, 7];
                    item = gen_1_1.value;
                    items.push(item);
                    _c.label = 6;
                case 6: return [3 /*break*/, 4];
                case 7: return [3 /*break*/, 14];
                case 8:
                    e_1_1 = _c.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 14];
                case 9:
                    _c.trys.push([9, , 12, 13]);
                    if (!(gen_1_1 && !gen_1_1.done && (_a = gen_1["return"]))) return [3 /*break*/, 11];
                    return [4 /*yield*/, _a.call(gen_1)];
                case 10:
                    _c.sent();
                    _c.label = 11;
                case 11: return [3 /*break*/, 13];
                case 12:
                    if (e_1) throw e_1.error;
                    return [7 /*endfinally*/];
                case 13: return [7 /*endfinally*/];
                case 14:
                    asyncGens_1_1 = asyncGens_1.next();
                    return [3 /*break*/, 2];
                case 15: return [3 /*break*/, 18];
                case 16:
                    e_2_1 = _c.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 18];
                case 17:
                    try {
                        if (asyncGens_1_1 && !asyncGens_1_1.done && (_b = asyncGens_1["return"])) _b.call(asyncGens_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 18: return [2 /*return*/, items];
            }
        });
    });
}
exports.drainSeqAsyncGen = drainSeqAsyncGen;
function endpointByCurrencyId(currencyId) {
    var endpoints = {
        solana: (0, env_1.getEnv)("API_SOLANA_PROXY"),
        solana_devnet: (0, web3_js_1.clusterApiUrl)("devnet"),
        solana_testnet: (0, web3_js_1.clusterApiUrl)("testnet")
    };
    if (currencyId in endpoints) {
        return endpoints[currencyId];
    }
    throw Error("unexpected currency id format <".concat(currencyId, ">, should be like solana[_(testnet | devnet)]"));
}
exports.endpointByCurrencyId = endpointByCurrencyId;
function asyncQueue(config) {
    var _this = this;
    var delayBetweenRuns = config.delayBetweenRuns;
    var q = [];
    var drain = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, lazyPromise, resolve, reject, _b, e_3;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(q.length > 0)) return [3 /*break*/, 5];
                    _a = q[q.length - 1], lazyPromise = _a.lazyPromise, resolve = _a.resolve, reject = _a.reject;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    _b = resolve;
                    return [4 /*yield*/, lazyPromise()];
                case 2:
                    _b.apply(void 0, [_c.sent()]);
                    return [3 /*break*/, 5];
                case 3:
                    e_3 = _c.sent();
                    reject(e_3);
                    return [3 /*break*/, 5];
                case 4:
                    void setTimeout(function () {
                        q.pop();
                        void drain();
                    }, delayBetweenRuns);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var submit = function (lazyPromise) {
        return new Promise(function (resolve, reject) {
            q.unshift({
                lazyPromise: lazyPromise,
                resolve: resolve,
                reject: reject
            });
            if (q.length === 1) {
                void drain();
            }
        });
    };
    return {
        submit: submit
    };
}
exports.asyncQueue = asyncQueue;
//# sourceMappingURL=utils.js.map